import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LMLocaleInitializerFactory, LMLocaleInitializerService } from '@services/lm-locale-initializer.service';

@NgModule({
  imports: [ CommonModule ],
  declarations: [],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: LMLocaleInitializerFactory,
      deps: [LMLocaleInitializerService],
      multi: true
    }
  ]
})
export class LMLocaleInitializerModule {}
